import { isWechat, isIOS, isSandbox, getParams } from './tools';
import store from '@/store/index';
import { getWxConfig } from '@/service/api'

export default {
    async initConfig(url: string) {
        if (!isWechat()) {
            return;
        }

        // 如果是 iOS 设备，则使用第一次进入App时的 URL 去请求 wxConfig，不然的话会导致 iOS 中分享的链接不对
        if (isIOS()) {
            // 记录第一次进入时的链接，iOS 分享时需要用到
            let { theFirstLink } = store.state.login;
            if (!theFirstLink) {
                store.commit('login/UPDATE_THEFIRSTLINK', url);
            } else {
                url = theFirstLink;
            }
        }

        // 将 url 传给后台请求微信签名配置
        let res: any = await getWxConfig({
            url,
            platform: isSandbox() ? 1 : 186,
        });
        const wx = (window as any).wx;
        if (res) {
            wx.config({
                debug: getParams('isDebug') === '1' ? true : false,  // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.appId,  // 必填，公众号的唯一标识
                nonceStr: res.nonceStr,  // 必填，生成签名的随机串
                signature: res.signature,  // 必填，签名，见附录1
                timestamp: res.timestamp,  // 必填，生成签名的时间戳
                jsApiList: ["updateAppMessageShareData", "updateTimelineShareData", "onMenuShareAppMessage", "onMenuShareTimeline"],  // 必填，需要使用的JS接口列表
            })
        }
    },

    share(data: any) {
        if (!isWechat()) {
            return;
        }

        const wx = (window as any).wx;
        wx.ready(() => {
            // 如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行
            // 在 weixin-js-sdk 1.4 之后，分享到朋友和朋友圈要分别使用 updateAppMessageShareData，updateTimelineShareData
            // 这里为了兼容老版本的微信，所以把以前的老版本的方法也写上
            wx.updateAppMessageShareData({
                title: data.title || '知屿-陪伴你的抉择',
                desc: data.desc || '这是一个神奇的游戏，快来测一下你2021年的桃花财运。',  // 分享描述,
                link: data.link || location.origin,  // 分享链接,
                imgUrl: data.imgUrl || 'https://img-fe.tengzhihh.com/image/fac91b8f3d51d5-180x180.png',  // 分享图标
                success: () => {
                    // 分享成功回调，分享成功后要做的事情可以写在这里，比如说上传分享成功信息给服务器，方便做统计
                }
            })
            wx.updateTimelineShareData({
                title: data.title || '知屿-陪伴你的抉择',  // 分享标题,
                link: data.link || location.origin,  // 分享链接,
                imgUrl: data.imgUrl || 'https://img-fe.tengzhihh.com/image/fac91b8f3d51d5-180x180.png',  // 分享图标
            })
            wx.onMenuShareAppMessage({  // 分享给朋友，此方法即将被废弃，改用 updateAppMessageShareData
                title: data.title || '知屿-陪伴你的抉择',
                desc: data.desc || '这是一个神奇的游戏，快来测一下你2021年的桃花财运。',  // 分享描述,
                link: data.link || location.origin,  // 分享链接,
                imgUrl: data.imgUrl || 'https://img-fe.tengzhihh.com/image/fac91b8f3d51d5-180x180.png',  // 分享图标
            })
            wx.onMenuShareTimeline({  // 分享到朋友圈，此方法即将被废弃，改用 updateTimelineShareData
                title: data.title || '知屿-陪伴你的抉择',  // 分享标题,
                link: data.link || location.origin,  // 分享链接,
                imgUrl: data.imgUrl || 'https://img-fe.tengzhihh.com/image/fac91b8f3d51d5-180x180.png',  // 分享图标
            })
            wx.error((res: any) => {
                // config信息验证失败会执行error函数，如签名过期导致验证失败，
                // 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                console.log(res)
            })
        })
    }
};

